import React from 'react';
import { Observe } from 'rewire-core';
import { Theme, WithStyle } from 'rewire-ui';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Loader from '../ui/Loader';
import RowSelectionGrid from '../ui/RowSelectionGrid';
import timecardSummaryModel from './TimecardSummaryModel';
import TimecardSummaryToolbar from './TimecardSummaryToolbar';
import { withStyles } from '../utility/styles';

const styles = (theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    padding: '0',
    overflow: 'hidden',
    position: 'relative',
  },
  paper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    marginBottom: '0px',
  },
  grid: {
    '& table': {
      marginBottom: '0 !important',
    },
    '& th': {
      whiteSpace: 'pre-wrap',
      paddingTop: '3px',
      paddingBottom: '3px',
    },
    '& tr.groupTotalRow td, & tr.groupTotalRow p, & tr.groupTotalRow td.selected': {
      backgroundColor: '#cbdbeb',
      outline: 'none',
      fontWeight: 'bold',
    },
    '& tr.totalRow td, & tr.totalRow p, & tr.totalRow td.selected': {
      color: 'darkslategray',
      outline: 'none',
      backgroundColor: '#cbebcb',
      fontWeight: 'bold',
      fontSize: '1.2em',
    },
    '& tr.reversal>td': {
      fontStyle: 'italic',
      textDecoration: 'line-through',
      color: theme.palette.error.main,
    },
    '& tr.reversal>td span': {
      paddingRight: 3,
    },
    '& .cellContainer': {
      height: 'auto',
    },
  },
  noResults: {
    fontStyle: 'italic',
    margin: '10px',
  },
});

interface ITimecardSummaryProps {
  className?: string;
}

type TimecardSummaryProps = WithStyle<ReturnType<typeof styles>, ITimecardSummaryProps>;

class TimecardSummaryView extends React.PureComponent<TimecardSummaryProps> {
  constructor(props: TimecardSummaryProps) {
    super(props);
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <TimecardSummaryToolbar />
        <Observe>
          {() => (
            <>
              <Loader loading={timecardSummaryModel.isLoading}>
                <Paper className={classes.paper} elevation={4}>
                  <Observe render={() => <RowSelectionGrid className={classes.grid} grid={timecardSummaryModel.grid} />} />
                </Paper>
              </Loader>

              <Observe
                render={() => {
                  return timecardSummaryModel.searchResultsMessage ? (
                    <Typography variant="h5" className={classes.noResults}>
                      {timecardSummaryModel.searchResultsMessage}
                    </Typography>
                  ) : null;
                }}
              />
            </>
          )}
        </Observe>
      </div>
    );
  }
}

export default withStyles<ITimecardSummaryProps>(styles, TimecardSummaryView);
